import { connect } from 'react-redux';
import { compose } from 'recompact';

import { withPreferredLocation } from 'src/app/hocs';
import { openChat } from 'src/app/state/slices/chat';
import type { Dispatch } from 'src/app/state/store';

import Renderer from '.';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  dispatchOpenChat: () => dispatch(openChat()),
});

export default compose(connect(null, mapDispatchToProps), withPreferredLocation)(Renderer);
